import angular from 'angular'
import routers from './routers.js'
import smallScaleTaskTraceCtrl from './smallScaleTaskTraceCtrl'

export default angular
  .module('declaration.addValTaxSmallScale.smallScaleTaskTrace', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('smallScaleTaskTraceCtrl', smallScaleTaskTraceCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/smallScaleTaskTrace/index.js